module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAWElEQVQ4jWNsaGhgwAXq6+thzP9QmrGxsRGnegYGBgYmvLJkgFEDB6GBjP///yesCinZEFJIdReyINlODCColiYuJBguDCSEIQu+vImUl+FgNC+PGkgDAwFabBEs4JxM8gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/images/block_add_curr.png
// module id = n5jL
// module chunks = 2